import { render } from "./Main.vue?vue&type=template&id=6102133e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=6102133e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6102133e"]])

export default __exports__